import PropTypes from 'prop-types';
import React from 'react';

const RECAPTCHA_CALLBACKS = 'recaptcha_callbacks';
const RECAPTCHA_JS = 'https://www.google.com/recaptcha/api.js';
const RECAPTCHA_JS_ID = 'recaptcha_js_id';
const WIN = typeof window !== 'undefined' ? window : {};

class ReCaptcha extends React.Component {
  static defaultProps = {
    callback: () => {},
    expiredCallback: () => {},
    onloadCallback: () => {},
    sitekey: '',
    size: 'normal',
    theme: 'light',
    type: 'image',
  };
  static propTypes = {
    /**
     * callback function to be executed when the user submits a successful CAPTCHA response. The user's response, g-recaptcha-response, will be the input for your callback function
     */
    callback: PropTypes.func,
    /**
     * callback function to be executed when the recaptcha response expires and the user needs to solve a new CAPTCHA
     */
    expiredCallback: PropTypes.func,
    /**
     * Forces the widget to render in a specific language.
     * Auto-detects if not specified
     */
    locale: PropTypes.string,
    /**
     * callback function to be executed once all the dependencies have loaded
     */
    onloadCallback: PropTypes.func,
    /**
     * Your sitekey.
     */
    sitekey: PropTypes.string.isRequired,
    /**
     * The size of the widget.
     */
    size: PropTypes.oneOf(['compact', 'normal']),
    /**
     * The color theme of the widget.
     */
    theme: PropTypes.oneOf(['light', 'dark']),
    /**
     * The type of CAPTCHA to serve.
     */
    type: PropTypes.oneOf(['image', 'audio']),
  };

  constructor(props) {
    super(props);
    this.widget = null;
  }

  componentWillMount() {
    const { locale, callback, onloadCallback, expiredCallback } = this.props;
    // detect if js already being loaded
    if (!WIN.grecaptcha && !document.getElementById(RECAPTCHA_JS_ID)) {
      const head = document.head || document.getElementsByTagName('head')[0];
      const script = document.createElement('script');
      script.id = RECAPTCHA_JS_ID;
      script.src = `${RECAPTCHA_JS}?&onload=${RECAPTCHA_CALLBACKS}_onloadCallback`;
      if (locale) {
        script.src = `${script.src}&hl=${locale}`;
      }
      script.type = 'text/javascript';
      script.async = true;
      script.defer = true;
      script.onerror = (oError) => {
        throw new URIError(`The script ${oError.target.src} is not accessible.`);
      };
      head.appendChild(script);
      WIN[`${RECAPTCHA_CALLBACKS}_callback`] = callback;
      WIN[`${RECAPTCHA_CALLBACKS}_expiredCallback`] = expiredCallback;
      WIN[`${RECAPTCHA_CALLBACKS}_onloadCallback`] = onloadCallback;
    }
  }
  componentWillUnmount() {
    delete WIN.grecaptcha;
    document.getElementById(RECAPTCHA_JS_ID).remove();
  }

  componentWillReceiveProps(nextProps) {
    const { callback, onloadCallback, expiredCallback } = nextProps;
    WIN[`${RECAPTCHA_CALLBACKS}_callback`] = callback;
    WIN[`${RECAPTCHA_CALLBACKS}_expiredCallback`] = expiredCallback;
    WIN[`${RECAPTCHA_CALLBACKS}_onloadCallback`] = onloadCallback;

    if (nextProps.reset && !this.props.reset && WIN.grecaptcha) {
      WIN.grecaptcha.reset();
      // we'll want to reset any previous response token that had been previously passed
      this.props.expiredCallback();
    }
  }

  _expiredCallback = () => {
    if (WIN.grecaptcha) {
      WIN.grecaptcha.reset();
    }
    this.props.expiredCallback();
  };

  render() {
    const { sitekey, theme, type, size } = this.props;

    return (
      <div
        ref="recaptcha"
        data-sitekey={sitekey}
        data-theme={theme}
        data-type={type}
        data-size={size}
        data-callback={`${RECAPTCHA_CALLBACKS}_callback`}
        data-testid="recaptcha"
        className="g-recaptcha recaptcha"
        data-expired-callback={`${RECAPTCHA_CALLBACKS}_expiredCallback`}
      />
    );
  }
}

export default ReCaptcha;
